// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Data_wrapper__1bEu1","item":"Data_item__3meEM","itemHeading":"Data_itemHeading__1Nn0z","itemColumns":"Data_itemColumns__3Z1Bp"};